import { render, staticRenderFns } from "./storeBalanceReport.vue?vue&type=template&id=52db5ca0&"
import script from "./storeBalanceReport.vue?vue&type=script&lang=js&"
export * from "./storeBalanceReport.vue?vue&type=script&lang=js&"
import style0 from "./storeBalanceReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports